/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { Trophy, Smartphone, Crown, Star, Award } from "lucide-react";
import { API, BACKEND_URL, DESIGN_W, DESIGN_H, resolveUrl, devLog, devError, devDebug, useViz } from "./visualizerShared";

export const WinnerOverlay = () => {
  const {
    audioUnlocked, setAudioUnlocked, leaderboard, setLeaderboard, currentVoter, setCurrentVoter,
    currentVote, setCurrentVote, showAnimation, setShowAnimation, countries, setCountries,
    voteApplied, setVoteApplied, backgroundVideo, setBackgroundVideo, fontTitle, setFontTitle,
    fontSubtitle, setFontSubtitle, fontCountry, setFontCountry, fontPoints, setFontPoints,
    fontVoting, setFontVoting, customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName,
    customFontSubtitleUrl, setCustomFontSubtitleUrl, customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl,
    customFontCountryName, setCustomFontCountryName, customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName,
    customFontVotingUrl, setCustomFontVotingUrl, customFontVotingName, setCustomFontVotingName, customFontsLoaded, setCustomFontsLoaded,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    logoUrl, setLogoUrl, logoPosition, setLogoPosition, logoSize, setLogoSize,
    logoZIndex, setLogoZIndex, logoOpacity, setLogoOpacity, extraImages, setExtraImages,
    fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle, fontSizeCountry, setFontSizeCountry,
    fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting, rowBgEven, setRowBgEven,
    rowBgOdd, setRowBgOdd, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, revealedVoters, setRevealedVoters, mystery12Text, setMystery12Text,
    twelveRevealed, setTwelveRevealed, voteDisplayColumns, setVoteDisplayColumns, showVoterBorder, setShowVoterBorder,
    showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary, customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl,
    customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled, overlay12DurationMode, setOverlay12DurationMode,
    overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle, overlay12BgColor, setOverlay12BgColor,
    overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives, overlay12UseAdminColors, setOverlay12UseAdminColors,
    overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle, overlay12FontCountry, setOverlay12FontCountry,
    overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale, overlay12Visible, setOverlay12Visible,
    overlay12RecipientId, setOverlay12RecipientId, overlay12Stage, setOverlay12Stage, winnerOverlayEnabled, setWinnerOverlayEnabled,
    winnerOverlayDurationMode, setWinnerOverlayDurationMode, winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle,
    winnerOverlayBgColor, setWinnerOverlayBgColor, winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText,
    winnerOverlaySubtitleText, setWinnerOverlaySubtitleText, winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayAccentColor, winnerOverlayIcon, winnerOverlayIconUrl, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti,
    winnerOverlayShowPoints, setWinnerOverlayShowPoints, winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle,
    winnerOverlayFontCountry, setWinnerOverlayFontCountry, winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale,
    winnerOverlayVisible, setWinnerOverlayVisible, winnerOverlayWinnerId, setWinnerOverlayWinnerId, winnerOverlayWinnerPoints, setWinnerOverlayWinnerPoints,
    allVotesApplied, setAllVotesApplied, orientation, setOrientation, showRotateHint, setShowRotateHint,
    videoRef, audioRef, sound12PointsUrlRef, confettiEnabledRef, confettiColorsRef, prevTwelveFromServerRef,
    prevOverlayVisibleRef, overlayAutoCloseTimerRef, overlayStageTimerRef, pollRef, fetchCurrentVoteRef, lastCountriesRef,
    lastBgConfigRef, lastRevealedRef, prevWinnerVisibleRef, winnerAutoCloseTimerRef, winnerConfettiIntervalRef, playVoterVideoWithSound,
    triggerTwelveRevealEffects, voterCountryId, voterShowAnimation, fetchLeaderboard, fetchCurrentVoter, fetchCountries,
    fetchBackground, fetchCurrentVote, fetchVotingStatus, fetchRevealedVoters, triggerWinnerConfetti, stopWinnerConfetti,
    fetchWinnerOverlay, computeDynamicSubtitle, getMedalClass, getTop3Color, getPositionalTranslucent, applyTranslucency,
    getMedalIcon, getPositionClass, half, leftColumn, rightColumn, getActiveFont,
  } = useViz();
  return (
      <AnimatePresence>
        {winnerOverlayVisible && winnerOverlayEnabled && (() => {
          const winnerCountry = winnerOverlayWinnerId ? countries.find(c => c.id === winnerOverlayWinnerId) : null;
          if (!winnerCountry) return null;

          const bgOpacityRatio = Math.max(0, Math.min(1, winnerOverlayBgOpacity / 100));
          let bgStyle = {};
          if (winnerOverlayBgStyle === "gradient") {
            const c1 = winnerOverlayUseAdminColors ? primaryColor : "#EC4899";
            const c2 = winnerOverlayUseAdminColors ? tertiaryColor : "#8B5CF6";
            const c3 = winnerOverlayUseAdminColors ? secondaryColor : "#FFD700";
            bgStyle = {
              background: `radial-gradient(ellipse at center, ${c3}${Math.round(bgOpacityRatio * 100).toString(16).padStart(2,'0')} 0%, transparent 50%), radial-gradient(ellipse at 30% 70%, ${c1}${Math.round(bgOpacityRatio * 180).toString(16).padStart(2,'0')} 0%, transparent 60%), radial-gradient(ellipse at 70% 30%, ${c2}${Math.round(bgOpacityRatio * 180).toString(16).padStart(2,'0')} 0%, transparent 60%), linear-gradient(135deg, #000000${Math.round(bgOpacityRatio * 255).toString(16).padStart(2,'0')} 0%, #1a0033${Math.round(bgOpacityRatio * 255).toString(16).padStart(2,'0')} 100%)`,
              backdropFilter: 'blur(24px)',
              WebkitBackdropFilter: 'blur(24px)'
            };
          } else if (winnerOverlayBgStyle === "solid") {
            const hex = winnerOverlayBgColor.replace('#', '');
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            bgStyle = {
              background: `rgba(${r}, ${g}, ${b}, ${bgOpacityRatio})`,
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)'
            };
          } else {
            bgStyle = {
              background: `rgba(0, 0, 0, ${bgOpacityRatio * 0.4})`,
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)'
            };
          }

          const accentColor = winnerOverlayUseAdminColors ? secondaryColor : "#FFD700";
          const titleColor = winnerOverlayUseAdminColors ? primaryColor : "#FFD700";

          // Custom style overrides for winner overlay
          const W_SCALE_MULT = { xs: 0.7, s: 0.85, m: 1, l: 1.2, xl: 1.5 };
          const wk = winnerOverlayStyleCustom ? (W_SCALE_MULT[winnerOverlaySizeScale] || 1) : 1;
          const wTitleFont = winnerOverlayStyleCustom ? winnerOverlayFontTitle : fontTitle;
          const wCountryFont = winnerOverlayStyleCustom ? winnerOverlayFontCountry : fontCountry;
          const wSecondaryFont = winnerOverlayStyleCustom ? winnerOverlayFontSecondary : fontVoting;
          const ovFont = (v, section) => v === 'OverlayCustom' ? 'WinnerCustomFont' : getActiveFont(v, section);
          const WinnerIcon = winnerOverlayIcon === 'crown' ? Crown : winnerOverlayIcon === 'star' ? Star : Trophy;

          return (
            <motion.div
              key="winner-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="fixed inset-0 z-[9999] flex items-center justify-center"
              style={bgStyle}
              data-testid="winner-overlay"
            >
              <button
                onClick={async () => {
                  try { await axios.post(`${API}/admin/hide-winner-overlay`); } catch (e) { devDebug('No se pudo ocultar el overlay del ganador (auto):', e?.message); }
                }}
                className="absolute top-6 right-6 px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 text-white text-sm backdrop-blur-md border border-white/20 transition-colors"
                data-testid="btn-close-winner-overlay"
              >
                Cerrar
              </button>

              <div className="flex flex-col items-center justify-center text-center px-12 max-w-6xl">
                {/* Title line 1 */}
                <motion.h2
                  initial={{ y: -30, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="text-white font-medium tracking-[0.12em] leading-tight"
                  style={{
                    fontFamily: `${ovFont(wTitleFont, "title")}, Inter, Arial, sans-serif`,
                    fontSize: `clamp(${26*wk}px, min(${3.6*wk}vw, ${6*wk}vh), ${58*wk}px)`,
                    textShadow: '0 0 30px rgba(255,255,255,0.6)'
                  }}
                >
                  {winnerOverlayTitleText}
                </motion.h2>

                {/* Winner country name (letter-spaced) */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.6, delay: 0.5 }}
                  className="text-white font-medium uppercase"
                  style={{
                    fontFamily: `${ovFont(wCountryFont, "country")}, Inter, Arial, sans-serif`,
                    fontSize: `clamp(${24*wk}px, min(${3.2*wk}vw, ${5.4*wk}vh), ${52*wk}px)`,
                    letterSpacing: '0.45em',
                    marginLeft: '0.45em',
                    textShadow: '0 0 30px rgba(255,255,255,0.6)'
                  }}
                  data-testid="winner-country-name"
                >
                  {winnerCountry.name}
                </motion.div>

                {/* Title line 2 (subtitle) */}
                {winnerOverlaySubtitleText && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.8 }}
                    className="text-white font-medium tracking-[0.12em]"
                    style={{
                      fontFamily: `${ovFont(wTitleFont, "title")}, Inter, Arial, sans-serif`,
                      fontSize: `clamp(${22*wk}px, min(${3*wk}vw, ${5*wk}vh), ${48*wk}px)`,
                      textShadow: '0 0 26px rgba(255,255,255,0.55)'
                    }}
                  >
                    {winnerOverlaySubtitleText}
                  </motion.div>
                )}

                {/* Winner artist PNG */}
                {winnerCountry.overlay_photo_url && (
                  <motion.img
                    src={resolveUrl(winnerCountry.overlay_photo_url)}
                    alt={winnerCountry.name}
                    initial={{ scale: 0.6, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.9, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
                    className="object-contain mt-2"
                    style={{ maxHeight: `clamp(${200*wk}px, ${36*wk}vh, ${480*wk}px)`, maxWidth: '70%' }}
                    onError={(e) => e.target.style.display = 'none'}
                    data-testid="winner-artist-photo"
                  />
                )}

                {/* Flag + Trophy row */}
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.6, delay: 1.4 }}
                  className="flex items-center justify-center gap-5 mt-3"
                >
                  {winnerCountry.flag_text ? (
                    <div
                      className="text-white font-black leading-none"
                      style={{
                        fontFamily: ovFont(wTitleFont, "title"),
                        fontSize: `clamp(${40*wk}px, ${5*wk}vw, ${72*wk}px)`,
                        textShadow: '0 0 24px rgba(255,255,255,0.6)'
                      }}
                    >
                      {winnerCountry.flag_text}
                    </div>
                  ) : winnerCountry.flag_url ? (
                    <img
                      src={resolveUrl(winnerCountry.flag_url)}
                      alt={winnerCountry.name}
                      className="object-contain"
                      style={{ height: `clamp(${48*wk}px, ${8*wk}vh, ${88*wk}px)`, borderRadius: '12px', filter: 'drop-shadow(0 0 16px rgba(255,255,255,0.7))' }}
                      onError={(e) => e.target.style.display = 'none'}
                    />
                  ) : null}
                  {winnerOverlayIcon === 'custom' && winnerOverlayIconUrl ? (
                    <img
                      src={resolveUrl(winnerOverlayIconUrl)}
                      alt="Icono ganador"
                      className="object-contain"
                      style={{
                        height: `clamp(${44*wk}px, ${7*wk}vh, ${80*wk}px)`,
                        filter: `drop-shadow(0 0 18px ${winnerOverlayAccentColor ? `${winnerOverlayAccentColor}B3` : 'rgba(255,255,255,0.7)'})`
                      }}
                      data-testid="winner-trophy"
                      onError={(e) => e.target.style.display = 'none'}
                    />
                  ) : (
                  <WinnerIcon
                    style={{
                      color: winnerOverlayAccentColor || '#FFFFFF',
                      width: `clamp(${44*wk}px, ${7*wk}vh, ${80*wk}px)`,
                      height: `clamp(${44*wk}px, ${7*wk}vh, ${80*wk}px)`,
                      filter: `drop-shadow(0 0 18px ${winnerOverlayAccentColor ? `${winnerOverlayAccentColor}B3` : 'rgba(255,255,255,0.7)'})`
                    }}
                    data-testid="winner-trophy"
                  />
                  )}
                </motion.div>

                {/* Artist name / song / points */}
                <motion.div
                  initial={{ y: 15, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.6, delay: 1.7 }}
                  className="mt-3 flex flex-col items-center gap-1"
                >
                  {winnerCountry.artist_name && (
                    <div
                      className="text-white font-semibold"
                      style={{
                        fontFamily: `${ovFont(wSecondaryFont, "voting")}, Inter, Arial, sans-serif`,
                        fontSize: `clamp(${18*wk}px, ${2*wk}vw, ${32*wk}px)`,
                        textShadow: '0 0 16px rgba(255,255,255,0.5)'
                      }}
                      data-testid="winner-artist-name"
                    >
                      {winnerCountry.artist_name}
                    </div>
                  )}
                  {winnerCountry.song_title && (
                    <div
                      className="text-white/90"
                      style={{
                        fontFamily: `${ovFont(wSecondaryFont, "voting")}, Inter, Arial, sans-serif`,
                        fontSize: `clamp(${16*wk}px, ${1.7*wk}vw, ${27*wk}px)`,
                        textShadow: '0 0 14px rgba(255,255,255,0.45)'
                      }}
                      data-testid="winner-song-title"
                    >
                      <span style={{ fontFamily: "Inter, Arial, sans-serif" }}>&lsquo;</span>{winnerCountry.song_title}<span style={{ fontFamily: "Inter, Arial, sans-serif" }}>&rsquo;</span>
                    </div>
                  )}
                  {winnerOverlayShowPoints && winnerOverlayWinnerPoints > 0 && (
                    <div
                      className="text-white/90 mt-1"
                      style={{
                        fontFamily: `${ovFont(wSecondaryFont, "points")}, Inter, Arial, sans-serif`,
                        fontSize: `clamp(${16*wk}px, ${1.7*wk}vw, ${27*wk}px)`,
                        textShadow: '0 0 14px rgba(255,255,255,0.45)'
                      }}
                      data-testid="winner-points"
                    >
                      {winnerOverlayWinnerPoints} p<span style={{ fontFamily: "Inter, Arial, sans-serif" }}>.</span>
                    </div>
                  )}
                </motion.div>
              </div>
            </motion.div>
          );
        })()}
      </AnimatePresence>
  );
};
